import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Container, Columns, Column, Button } from '@resurs/midas-react'
import { Autocomplete } from '../../midasComponents'

import Page from '../../internal/Page'

import { getText } from '../../internal/TextLabels'

const StoreSelectUI = ({
  representatives,
  stores,
  selectedRepresentative,
  selectedStore,
  storeValid,
  onChangeRepresentativeSearchTerm,
  onChangeRepresentative,
  onChangeStoreSearchTerm,
  onChangeStore,
  onClearRepresentative,
  onClearStore,
  onSaveClick,
  onCancelClick,
}) => (
  <Container>
    <Columns>
      <Column col3 colMd2 colSm0 />
      <Column col6 colMd8 colSm12>
        <Page title={getText('store.select.representativeAndStore')}>
          <Container>
            <Columns>
              <Column col12>
                <Autocomplete
                  id="representative-select"
                  label={getText('store.select.representative')}
                  placeholder={getText(
                    'store.select.representativePlaceholder',
                  )}
                  loading={false}
                  values={representatives}
                  searchTerm={onChangeRepresentativeSearchTerm}
                  onChange={onChangeRepresentative}
                  onClear={onClearRepresentative}
                />
                {selectedRepresentative && (
                  <>
                    <Autocomplete
                      id="store-select"
                      label={getText('store.select.store')}
                      placeholder={getText('store.select.storePlaceholder')}
                      loading={false}
                      values={stores}
                      searchTerm={onChangeStoreSearchTerm}
                      onChange={onChangeStore}
                      onClear={onClearStore}
                    />
                    {selectedStore && !storeValid && (
                      <span className={midas.formInputHint}>
                        {getText('login.invalidStoreLoginError')}
                      </span>
                    )}
                  </>
                )}
              </Column>
              <Column col12>
                <Button onClick={onCancelClick}>
                  {getText('default.cancel')}
                </Button>
                <div className={midas.floatRight}>
                  <Button
                    type="primary"
                    onClick={onSaveClick}
                    disabled={
                      !(
                        !!selectedRepresentative &&
                        !!selectedStore &&
                        storeValid
                      )
                    }
                  >
                    {getText('default.continue')}
                  </Button>
                </div>
              </Column>
            </Columns>
          </Container>
        </Page>
      </Column>
    </Columns>
  </Container>
)

StoreSelectUI.propTypes = {
  representatives: PropTypes.array.isRequired,
  stores: PropTypes.array.isRequired,
  selectedRepresentative: PropTypes.object,
  selectedStore: PropTypes.object,
  storeValid: PropTypes.bool.isRequired,
  onChangeRepresentativeSearchTerm: PropTypes.func.isRequired,
  onChangeRepresentative: PropTypes.func.isRequired,
  onChangeStoreSearchTerm: PropTypes.func.isRequired,
  onChangeStore: PropTypes.func.isRequired,
  onClearRepresentative: PropTypes.func.isRequired,
  onClearStore: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
}

StoreSelectUI.defaultProps = {
  selectedRepresentative: null,
  selectedStore: null,
}

export default StoreSelectUI
